/* eslint-disable perfectionist/sort-imports */
import { b, constVoid, DOM, IOO, pipe, RA, RNEA, RR, s, v } from '@packages/prelude'
import { Navigation, Pagination, Swiper, SwiperOptions } from 'swiper'
import '../css/main.scss'
import 'bootstrap'

pipe(
  IOO.of({ document }),
  IOO.chain(({ document }) => pipe(document, DOM.querySelector('body.home > .navbar'))),
  IOO.map(navbar =>
    DOM.addEventListener('scroll')(
      () => () =>
        pipe(
          window.scrollY > window.innerHeight * 0.6,
          b.match(
            () => navbar.classList.contains('bg-gradient') && navbar.classList.remove('bg-gradient'),
            () => !navbar.classList.contains('bg-gradient') && navbar.classList.add('bg-gradient')
          )
        )
    )(window)()
  )
)()

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelector(`#${selector}`)) as IOO.IOOption<HTMLElement>),
    IOO.fold(
      () => constVoid,
      element => IOO.of(new Swiper(element, options))
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  categorySlider: {
    modules: [Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 24,
    navigation: {
      nextEl: '.category-button-next',
      prevEl: '.category-button-prev'
    },
    pagination: {
      el: '.category-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)

/* filtering posts */

pipe(
  IOO.of({ document }),
  IOO.bind(
    'inputs',
    ({ document }) =>
      pipe(document, DOM.querySelectorAll('form#filterCategories input')) as unknown as IOO.IOOption<
        RNEA.ReadonlyNonEmptyArray<HTMLInputElement>
      >
  ),
  IOO.bind(
    'posts',
    ({ document }) =>
      pipe(document, DOM.querySelectorAll('.filtered-posts .post')) as unknown as IOO.IOOption<
        RNEA.ReadonlyNonEmptyArray<HTMLElement>
      >
  ),
  IOO.bind('disturber', ({ document }) => pipe(document, DOM.querySelector('.disturber')) as IOO.IOOption<HTMLElement>),
  IOO.map(({ inputs, posts, disturber }) =>
    pipe(
      inputs,
      RNEA.map(input =>
        DOM.addEventListener('change')(() => () => {
          const checkedInputs = pipe(
            inputs,
            RA.filter(input => input.checked),
            RA.map(input => input.id)
          )

          pipe(
            posts,
            RNEA.map(post => {
              const isChecked = checkedInputs.includes(post.id)
              const isAllChecked = checkedInputs.length === inputs.length
              const isNoneChecked = checkedInputs.length === 0

              const showPost = isAllChecked || isNoneChecked || isChecked
              const showDisturber = isAllChecked || isNoneChecked

              disturber.style.display = showDisturber ? 'flex' : 'none'

              post.style.display = showPost ? 'block' : 'none'
            })
          )
        })(input)()
      )
    )
  )
)()
